module.exports = __webpack_public_path__ + "img/140.b3b4f4cf.jpg";